import React, { useEffect, useState } from "react"
import { Grid } from "@material-ui/core"
import {
  InputTextMaster,
  InputOptionMaster,
  InputCheckboxMaster,
} from "App/Component/ui"
import { useProvinsi2, useDistrict2, useSubDistrict2, useCity2 } from "."
import { messageError } from "utils/all"
import { useSelectOption } from "App/hooks"
import { TYPE_INSTANCE_REGISTRASI_EMR_V3 } from "App/constants"

export default function FormAlamat({ formData, setFormData, handleChange }) {
  const [isKtp, setIsKtp] = useState(false)
  const listNegara = useSelectOption(
    true,
    "/master/lokasi/lok-ms-negaras/resource",
    TYPE_INSTANCE_REGISTRASI_EMR_V3,
    "value",
    "label",
    "data",
  )
  const listProv2 = useProvinsi2(formData.country)
  const listCity2 = useCity2(formData.province)
  const listDistrict2 = useDistrict2(formData.city)
  const listSubDistrict2 = useSubDistrict2(formData.district)

  useEffect(() => {
    if (isKtp) {
      setFormData({
        ...formData,
        address_now: formData.address_ktp,
        is_same_with_ktp: 1,
      })
    } else {
      setFormData({
        ...formData,
        address_now: "",
        is_same_with_ktp: 0,
      })
    }
  }, [isKtp]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <p className="fw-600 mt-2">ALAMAT</p>
      <div className="mt-1">
        <Grid container spacing={1}>
          <Grid item sm={6}>
            <InputTextMaster
              name="alamat_ktp"
              label="ALAMAT KTP"
              id="alamat_ktp"
              placeholder="Alamat Sesuai KTP"
              value={formData.address_ktp}
              onChange={handleChange("address_ktp")}
              error={true}
              message={messageError.required}
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name="alamat_sekarang"
              label="ALAMAT SEKARANG"
              id="alamat_sekarang"
              value={formData.address_now}
              placeholder="Alamat Pasien Saat ini"
              onChange={handleChange("address_now")}
              disabled={isKtp ? true : false}
              error={true}
              message={messageError.required}
            />
            <div
              style={{
                cursor: "pointer",
                marginTop: "-3.7rem",
                position: "absolute",
                right: "2.5rem",
              }}
            >
              <InputCheckboxMaster
                checked={isKtp}
                name="is_ktp"
                id="is_ktp"
                label="Alamat Sama Dengan KTP"
                onChange={() => setIsKtp(!isKtp)}
              />
            </div>
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="rw"
              label="RW"
              id="rw"
              value={formData.rw}
              placeholder="RW"
              onChange={handleChange("rw")}
              error={true}
              // message={messageError.required}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="rt"
              label="RT"
              id="rt"
              value={formData.rt}
              placeholder="RT"
              onChange={handleChange("rt")}
              error={true}
              // message={messageError.required}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="postal_code"
              label="KODE POS"
              id="postal_code"
              value={formData.postal_code}
              placeholder="Kode Pos"
              onChange={handleChange("postal_code")}
              error={true}
              // message={messageError.required}
            />
          </Grid>

          <Grid item xs={6} sm={3}>
            <InputOptionMaster
              name="negara"
              label="NEGARA"
              id="negara"
              onChange={handleChange("country")}
              value={formData.country}
              needParse={false}
              labelValue={formData.country_name}
              data={listNegara}
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <InputOptionMaster
              name="provinsi"
              label="PROVINSI"
              id="provinsi"
              needParse={false}
              value={formData.province}
              withSearch={true}
              labelValue={formData.province_name}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  province: e?.value,
                  province_name: e?.label,
                  city: null,
                  city_name: "Pilih Kota",
                  district: null,
                  district_name: "Pilih Kecamatan",
                  sub_district: null,
                  sub_district_name: "Pilih Kelurahan",
                })
              }}
              data={listProv2}
              error={true}
              message={messageError.required}
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <InputOptionMaster
              name="kota"
              label="KOTA"
              id="kota"
              needParse={false}
              value={formData.city}
              withSearch={true}
              labelValue={formData.city_name}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  city: e?.value,
                  city_name: e?.label,
                  district: null,
                  district_name: "Pilih Kecamatan",
                  sub_district: null,
                  sub_district_name: "Pilih Kelurahan",
                })
              }}
              data={listCity2}
              error={true}
              message={messageError.required}
            />
          </Grid>

          <Grid item xs={6} sm={3}>
            <InputOptionMaster
              name="dictrict"
              label="KECAMATAN"
              id="dictrict"
              needParse={false}
              value={formData.district}
              withSearch={true}
              labelValue={formData.district_name}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  district: e?.value,
                  district_name: e?.label,
                  sub_district: null,
                  sub_district_name: "Pilih Kelurahan",
                })
              }}
              data={listDistrict2}
              error={true}
              message={messageError.required}
            />
          </Grid>

          <Grid item xs={6} sm={3}>
            <InputOptionMaster
              name="sub_district"
              label="KELURAHAN"
              id="sub_district"
              needParse={false}
              value={formData.sub_district}
              withSearch={true}
              labelValue={formData.sub_district_name}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  sub_district: e?.value,
                  sub_district_name: e?.label,
                })
              }}
              data={listSubDistrict2}
              error={true}
              message={messageError.required}
            />
          </Grid>
        </Grid>
      </div>
    </>
  )
}
